import "./Footer.css";

const Footer = () => {
  return (
  <div className="footer-div">
    <footer>
      <p>© Artem Furman, Cindy Mit, Emanuella Altidor, Joel Giroux - May 2021</p>
    </footer>
    </div>
  )
};

export default Footer;